




























import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class DownloadRecords extends Vue {
  //   @Prop() downloadType!: string;
  @Prop() recordType!: string;
  @Prop() recordsData!: any;
  public jsonFields: any;
  public jsonData: any;
  public jsonMeta: any;
  public title: string;
  constructor() {
    super();
    this.jsonFields = {};
    this.jsonData = [];
    this.jsonMeta = [
      [
        {
          key: "charset",
          value: "utf-8"
        }
      ]
    ];
    this.title = "";
  }
  created() {
    var statusAttestatoFinale = "";
    if (this.recordType === "elencoAziende") {
      this.title = "Elenco Aziende";
      this.jsonFields = {
        "Denominazione": "denominazioneAzienda",
        "PIva": "pIva",
        "Cognome Rappresentante": "cognomeRappresentanteAzienda",
        "Nome Rappresentante": "nomeRappresentanteAzienda",
        "Stato Nascita Rappresentante": "statoNascitaRappresentante",
        "Data Nascita Rappresentante": "dataNascitaRappresentante",
        "Luogo Nascita Rappresentante": "luogoNascitaRappresentante",
        "Comune Azienda": "comuneAzienda",
        "Provincia Azienda": "provinciaAzienda",
        "Indirizzo Azienda": "indirizzoAzienda",
        "Cap": "cap",
        "Nazione Azienda": "nazioneAzienda",
        "Telefono 1 Azienda": "telefono1Azienda",
        "Telefono 2 Azienda": "telefono2Azienda",
        "Fax Azienda": "faxAzienda",
        "Email Azienda": "emailAzienda",
        "Pec Azienda": "pecAzienda",
        "Sito Azienda": "sitoAzienda",
        "Attività Azienda": "attivitàAzienda",
        "N° Dipendenti": "dipendentiAzienda",
        "Associata Confindustria": "associata",
        "Azienda Artigiana": "artigiana",
        "Codice Fiscale Azienda": "codAzienda",
        "Cod ATECO": "descrizioneAteco",
        "Stato Nomina Responsabile": "idStatoDoc",
        "Nomina Responsabile obsoleta": "obsoleto"
      };
    } else if (this.recordType === "elencoAllievi") {
      this.title = "Elenco Allievi";
      this.jsonFields = {
        "Nome Allievo": "nomeUtente",
        "Cognome Allievo": "cognomeUtente",
        "Codice Fiscale": "cod",
        "Indirizzo Allievo": "indirizzoUtente",
        "Comune Allievo": "comuneUtente",
        "Provincia Allievo": "provinciaUtente",
        "Cap": "cap",
        "Telefono 1 Allievo": "telefono1Utente",
        "Telefono 2 Allievo": "telefono2Utente",
        "Email Allievo": "emailUtente",
        "Pec Allievo": "pecUtente",
        "Data Nascita Allievo": "dataNascita",
        "Luogo Nascita Allievo": "luogoNascita",
        "Username": "username",
        "Classe": "classe",
        "Stato Patto Corresponsabilità": "idStatoDoc"
      };
    } else if (this.recordType === "assegnazioniTutorSettore") {
      this.title = "Assegnazioni Tutor Articolazioni";
      this.jsonFields = {
        "Nome Allievo": "nomeUtente",
        "Cognome Allievo": "cognomeUtente",
        "Classe Allievo": "classe",
        "Indirizzo Allievo": "indirizzoUtente",
        "Comune Allievo": "comuneUtente",
        "Provincia Allievo": "provinciaUtente",
        "Cap": "cap",
        "Telefono 1 Allievo": "telefono1Utente",
        "Telefono 2 Allievo": "telefono2Utente",
        "Email Allievo": "emailUtente",
        "Iscritto": "iscritto",
        "Blocco Attivita": "bloccato",
        "Tutor Articolazione": "tutor",
        "Corso Sicurezza": "corsoSicurezza"
      };
    } else if (this.recordType === "abbinamentiTirociniEstivi") {
      this.title = "Abbinamenti Tirocini Estivi";
      this.jsonFields = {
        "Allievo": "allievo",
        "Classe": "classe",
        "Codice Fiscale": "cod",
        "Indirizzo Allievo": "indirizzoUtente",
        "Comune Allievo": "comuneUtente",
        "Provincia Allievo": "provinciaUtente",
        "Telefono 1 Allievo": "telefono1Utente",
        "Telefono 2 Allievo": "telefono2Utente",
        "Email Allievo": "emailUtente",
        "Pec Allievo": "pecUtente",
        "Data Nascita Allievo": "dataNascita",
        "Luogo Nascita Allievo": "luogoNascita",
        "Azienda": "denominazioneAzienda",
        "PIva": "pIva",
        "Cognome Rappresentante": "cognomeRappresentanteAzienda",
        "Nome Rappresentante": "nomeRappresentanteAzienda",
        "Stato Nascita Rappresentante": "statoNascitaRappresentante",
        "Data Nascita Rappresentante": "dataNascitaRappresentante",
        "Luogo Nascita Rappresentante": "luogoNascitaRappresentante",
        "Comune Azienda": "comuneAzienda",
        "Provincia Azienda": "provinciaAzienda",
        "Indirizzo Azienda": "indirizzoAzienda",
        "Nazione Azienda": "nazioneAzienda",
        "Telefono 1 Azienda": "telefono1Azienda",
        "Telefono 2 Azienda": "telefono2Azienda",
        "Fax Azienda": "faxAzienda",
        "Email Azienda": "emailAzienda",
        "Pec Azienda": "pecAzienda",
        "Sito Azienda": "sitoAzienda",
        "Attività Azienda": "attivitàAzienda",
        "N° Dipendenti": "dipendentiAzienda",
        "Tirocini Sede": "tirociniSede",
        "Tirocini Disabili Sede": "tirociniDisabiliSede",
        "Associata Confindustria": "associata",
        "Azienda Artigiana": "artigiana",
        "Codice Fiscale Azienda": "codAzienda",
        "Cod ATECO": "descrizioneAteco",
        "Cod ISTAT": "descrizioneIstat",
        "Tutor Formativo": "tutorFormativo",
        "Indirizzo Tirocinio": "indirizzoTirocinio",
        "Comune Tirocinio": "comuneTirocinio",
        "Provincia Tirocinio": "provinciaTirocinio",
        "Cap Tirocinio": "capTirocinio",
        "Tutor Aziendale": "tutorAzienda",
        "Email Tutor Aziendale": "emailTutor",
        "Telefono Tutor Aziendale": "telefonoTutor",
        "Tipologia Consulente": "consulente",
        "Denominazione Consulente": "denominazioneConsulente",
        "Referente Consulente": "referenteConsulente",
        "Telefono Referente Consulente": "telefonoConsulente",
        "Email Referente Consulente": "emailConsulente",
        "Attività Tirocinio": "attivitàTirocinio",
        "Uso Fuori Sede": "usoFuoriSede",
        "Indirizzo Studio": "nomeIndirizzoStudio",
        "Codice CP Istat": "descrizioneCPIstat",
        "Data Inizio Periodo": "dataInizioPeriodo",
        "Data Fine Periodo": "dataFinePeriodo",
        "Orario Inizio Mattino": "orarioInizioMattino",
        "Orario Fine Mattino": "orarioFineMattino",
        "Orario Inizio Pomeriggio": "orarioInizioPomeriggio",
        "Orario Fine Pomeriggio": "orarioFinePomeriggio",
        "Convenzione": "idConvenzione",
        "Progetto Orientamento": "idProgettoOrientamento",
        "Numero Protocollazione": "numeroProtocollazione",
        "Data Protocollazione": "dataProtocollazione"
      };
    }else if(this.recordType === "abbinamentiAlternanza"){
      this.title = "Abbinamenti PCTO";
      this.jsonFields = {
        "Allievo": "allievo",
        "Classe": "classe",
        "Codice Fiscale": "cod",
        "Indirizzo Allievo": "indirizzoUtente",
        "Comune Allievo": "comuneUtente",
        "Provincia Allievo": "provinciaUtente",
        "Telefono 1 Allievo": "telefono1Utente",
        "Telefono 2 Allievo": "telefono2Utente",
        "Email Allievo": "emailUtente",
        "Pec Allievo": "pecUtente",
        "Data Nascita Allievo": "dataNascita",
        "Luogo Nascita Allievo": "luogoNascita",
        "Azienda": "denominazioneAzienda",
        "PIva": "pIva",
        "Cognome Rappresentante": "cognomeRappresentanteAzienda",
        "Nome Rappresentante": "nomeRappresentanteAzienda",
        "Stato Nascita Rappresentante": "statoNascitaRappresentante",
        "Data Nascita Rappresentante": "dataNascitaRappresentante",
        "Luogo Nascita Rappresentante": "luogoNascitaRappresentante",
        "Comune Azienda": "comuneAzienda",
        "Provincia Azienda": "provinciaAzienda",
        "Indirizzo Azienda": "indirizzoAzienda",
        "Nazione Azienda": "nazioneAzienda",
        "Telefono 1 Azienda": "telefono1Azienda",
        "Telefono 2 Azienda": "telefono2Azienda",
        "Fax Azienda": "faxAzienda",
        "Email Azienda": "emailAzienda",
        "Pec Azienda": "pecAzienda",
        "Sito Azienda": "sitoAzienda",
        "Attività Azienda": "attivitàAzienda",
        "N° Dipendenti": "dipendentiAzienda",
        "Tirocini Sede": "tirociniSede",
        "Tirocini Disabili Sede": "tirociniDisabiliSede",
        "Associata Confindustria": "associata",
        "Azienda Artigiana": "artigiana",
        "Codice Fiscale Azienda": "codAzienda",
        "Cod ATECO": "descrizioneAteco",
        "Cod ISTAT": "descrizioneIstat",
        "Tutor Formativo": "tutorFormativo",
        "Tutor Articolazione": "tutorArticolazione",
        "Indirizzo Tirocinio": "indirizzoTirocinio",
        "Comune Tirocinio": "comuneTirocinio",
        "Provincia Tirocinio": "provinciaTirocinio",
        "Cap Tirocinio": "capTirocinio",
        "Tutor Aziendale": "tutorAzienda",
        "Email Tutor Aziendale": "emailTutor",
        "Telefono Tutor Aziendale": "telefonoTutor",
        "Tipologia Consulente": "consulente",
        "Denominazione Consulente": "denominazioneConsulente",
        "Referente Consulente": "referenteConsulente",
        "Telefono Referente Consulente": "telefonoConsulente",
        "Email Referente Consulente": "emailConsulente",
        "Attività Tirocinio": "attivitàTirocinio",
        "Uso Fuori Sede": "usoFuoriSede",
        "Indirizzo Studio": "nomeIndirizzoStudio",
        "Codice CP Istat": "descrizioneCPIstat",
        "Data Inizio Periodo": "dataInizioPeriodo",
        "Data Fine Periodo": "dataFinePeriodo",
        "Orario Inizio Mattino": "orarioInizioMattino",
        "Orario Fine Mattino": "orarioFineMattino",
        "Orario Inizio Pomeriggio": "orarioInizioPomeriggio",
        "Orario Fine Pomeriggio": "orarioFinePomeriggio",
        "Convenzione": "idConvenzione",
        "Numero Protocollazione": "numeroProtocollazione",
        "Data Protocollazione": "dataProtocollazione",
        "Firma Convenzione Azienda": {
          field: "firmaConvenzioneAz",
          callback: ((value: any) =>{
            if (value !== null && value !== ""){
              return "Firmata"
            }else{
              return "Non Firmata"
            }
          })
        },
        "Firma Percorso Formativo Azienda": {
          field: "firmaPercorsoAz",
          callback: ((value: any) =>{
            if (value !== null && value !== ""){
              return "Firmato"
            }else{
              return "Non Firmato"
            }
          })
        },
        "Firma Percorso Formativo Tirocinante": {
          field: "firmaPercorsoTir",
          callback: ((value: any) =>{
            if (value !== null && value !== ""){
              return "Firmato"
            }else{
              return "Non Firmato"
            }
          })
        },
        "Attestato Finale": {
          field: "idAttestatoFinale",
          callback: ((value: any) =>{
            if (value !== null && value !== ""){
              return "Compilato"
            }else{
              return "Non Compilato"
            }
          })
        },
        "Data Attestato Finale": "dataAttestatoFinale",
        "Questionario Azienda": {
          field: "idQuestAzienda",
          callback: ((value: any) =>{
            if (value !== null && value !== ""){
              return "Compilato"
            }else{
              return "Non Compilato"
            }
          })
        },
        "Ore PCTO": {
          field: "totOre",
          callback: ((value: any) =>{
            if (value !== null && value !== ""){
              return value
            }else{
              return ""
            }  
          })
        },
        "Questionario Allievo": {
          field: "idQuestTirocinante",
          callback: ((value: any) =>{
            if (value !== null && value !== ""){
              return "Compilato"
            }else{
              return "Non Compilato"
            }
          })
        }
      };
    }else if(this.recordType === "iscrizioniWorshop"){
      this.title = "Iscrizioni Workshop";
      this.jsonFields = {
        "Azienda": "denominazioneAzienda",
        "Sede Azienda": "comuneAzienda",
        "Email Azienda": "emailAzienda",
        "Settore": "nomeArticolazione",
        "Id Settore": "idArticolazione",
        "Risorse da inserire": "scelta",
        "Referente": "referente",
        "Email Referente": "emailReferente"
      }
    }else if(this.recordType === "schedulazioniWorkshop"){
      this.title = "Schedulazioni Workshop";
      this.jsonFields = {
        "Azienda": "denominazioneAzienda",
        "Email Azienda": "emailAzienda",
        "Email Referente": "emailReferente",
        "Settore": "nomeArticolazione",
        "Giorno": "giorno",
        "Turno": "turno",
        "Presente": "presenzaWorkshop"
      }
    }else if (this.recordType == "abbinamentiTirFormativi" || this.recordType === "abbinamentiTirReIns"){
      if (this.recordType == "abbinamentiTirFormativi"){
        this.title = "Abbinamenti Tirocini Formativi"
      }else{
        this.title = "Abbinamenti Tirocini Inserimento/Reinserimento";
      }
      this.jsonFields = {
          "Allievo": "allievo",
          "Classe": "classe",
          "Codice Fiscale": "cod",
          "Indirizzo Allievo": "indirizzoUtente",
          "Comune Allievo": "comuneUtente",
          "Provincia Allievo": "provinciaUtente",
          "Telefono 1 Allievo": "telefono1Utente",
          "Telefono 2 Allievo": "telefono2Utente",
          "Email Allievo": "emailUtente",
          "Pec Allievo": "pecUtente",
          "Data Nascita Allievo": "dataNascita",
          "Luogo Nascita Allievo": "luogoNascita",
          "Azienda": "denominazioneAzienda",
          "PIva": "pIva",
          "Cognome Rappresentante": "cognomeRappresentanteAzienda",
          "Nome Rappresentante": "nomeRappresentanteAzienda",
          "Stato Nascita Rappresentante": "statoNascitaRappresentante",
          "Data Nascita Rappresentante": "dataNascitaRappresentante",
          "Luogo Nascita Rappresentante": "luogoNascitaRappresentante",
          "Comune Azienda": "comuneAzienda",
          "Provincia Azienda": "provinciaAzienda",
          "Indirizzo Azienda": "indirizzoAzienda",
          "Nazione Azienda": "nazioneAzienda",
          "Telefono 1 Azienda": "telefono1Azienda",
          "Telefono 2 Azienda": "telefono2Azienda",
          "Fax Azienda": "faxAzienda",
          "Email Azienda": "emailAzienda",
          "Pec Azienda": "pecAzienda",
          "Sito Azienda": "sitoAzienda",
          "Attività Azienda": "attivitàAzienda",
          "N° Dipendenti": "dipendentiAzienda",
          "Tirocini Sede": "tirociniSede",
          "Tirocini Disabili Sede": "tirociniDisabiliSede",
          "Associata Confindustria": "associata",
          "Azienda Artigiana": "artigiana",
          "Codice Fiscale Azienda": "codAzienda",
          "Cod ATECO": "descrizioneAteco",
          "Cod ISTAT": "descrizioneIstat",
          "Tutor Formativo": "tutorFormativo",
          "Indirizzo Tirocinio": "indirizzoTirocinio",
          "Comune Tirocinio": "comuneTirocinio",
          "Provincia Tirocinio": "provinciaTirocinio",
          "Cap Tirocinio": "capTirocinio",
          "Tutor Aziendale": "tutorAzienda",
          "Email Tutor Aziendale": "emailTutor",
          "Telefono Tutor Aziendale": "telefonoTutor",
          "Tipologia Consulente": "consulente",
          "Denominazione Consulente": "denominazioneConsulente",
          "Referente Consulente": "referenteConsulente",
          "Telefono Referente Consulente": "telefonoConsulente",
          "Email Referente Consulente": "emailConsulente",
          "Attività Tirocinio": "attivitàTirocinio",
          "Uso Fuori Sede": "usoFuoriSede",
          "Indirizzo Studio": "nomeIndirizzoStudio",
          "Codice CP Istat": "descrizioneCPIstat",
          "Data Inizio Periodo": "dataInizioPeriodo",
          "Data Fine Periodo": "dataFinePeriodo",
          "Orario Inizio Mattino": "orarioInizioMattino",
          "Orario Fine Mattino": "orarioFineMattino",
          "Orario Inizio Pomeriggio": "orarioInizioPomeriggio",
          "Orario Fine Pomeriggio": "orarioFinePomeriggio",
          "Convenzione": "idConvenzione",
          "Numero Protocollazione": "numeroProtocollazione",
          "Data Protocollazione": "dataProtocollazione"
        }
    }else if(this.recordType === "dettagliReport"){
      this.title = "Report";
      this.jsonFields = {
        "Tutor Formativo": "tutorFormativo",
        "Tirocinante": "tirocinante",
        "Azienda": "denominazioneAzienda",
        "Data Visita": "dataVisita",
        "Attività": "attivita",
        "Data Inizio Periodo": "dataInizio",
        "Data Fine Periodo": "dataFine",
        "Ora Inizio Mattina": "orarioInizioMattina",
        "Ora Fine Mattina": "orarioFineMattina",
        "Ora Inizio Pomeriggio": "orarioInizioPomeriggio",
        "Ora Fine Pomeriggio": "orarioFinePomeriggio",
        "Ora Visita": "oraVisita",
        "Tipo Visita": "tipoVisita",
        "Personale Contattato": "personaleContattato",
        "Presenza Stagista": "presenzaStagista",
        "Colloquio Stagista": "colloquioStagista",
        "Attività Coerente": "attivitaCoerente",
        "Motivazione non Coerenza": "motivazioneNonCoerenza",
        "Note": "note",
        "Data Report": "dataReport",
        "Ora Report": "oraReport"
      }
    }else if(this.recordType === "dettagliRichiesteAlternanza"){
      this.title = "Disponibilità PCTO";
      this.jsonFields = {
        "Azienda": "denominazioneAzienda",
        "P.Iva": "pIva",
        "Cognome Rappresentante": "cognomeRappresentanteAzienda",
        "Nome Rappresentante": "nomeRappresentanteAzienda",
        "Email Azienda": "emailAzienda",
        "Telefono Azienda": "telefono1Azienda",
        "Ateco": "descrizioneAteco",
        "Nome Tirocinante Indicato": "nomeTirocinante",
        "Cognome Tirocinante Indicato": "cognomeTirocinante",
        "Classe Tirocinante Indicato": "classeTirocinante",
        "Lavoratori Sede": "lavoratoriSede",
        "Tirocini Sede": "tirociniSede",
        "Di cui disabili": "tirociniDisabiliSede",
        "Attività": "attivitàTirocinio",
        "Indirizzo Studio": "nomeIndirizzoStudio",
        "Istat": "descrizioneIstat",
        "Uso Fuori Sede": "usoFuoriSede",
        "Indirizzo Tirocinio": "indirizzoTirocinio",
        "Comune Tirocinio": "comuneTirocinio",
        "Cap Tirocinio": "capTirocinio",
        "Provincia Tirocinio": "provinciaTirocinio",
        // "Data Inizio": "dataInizioPeriodo",
        // "Data Fine": "dataFinePeriodo",
        // "Orario Inizio Mattino": "orarioInizioMattino",
        // "Orario Fine Mattino": "orarioFineMattino",
        // "Orario Inizio Pomeriggio": "orarioInizioPomeriggio",
        // "Orario Fine Pomeriggio": "orarioFinePomeriggio",
        "Consulente": "consulente",
        "Denominazione Consulente": "denominazioneConsulente",
        "Referente": "referenteConsulente",
        "Telefono Referente": "telefonoConsulente",
        "Email Referente": "emailConsulente",
        "Uso Ufficio": "usoUfficio",
        "Uso Produzione": "usoProduzione",
        "Uso Cantiere": "usoCantiere",
        "Altro Uso": "usoAltro",
        "Sorveglianza Sanitaria": "sorveglianzaSanitaria",
        "Formazione": "formazione",
        "Colloquio": "colloquio",
        "Formazione Tutor Sicurezza": "formazioneTutorSicurezza",
        "Formazione Tutor Tirocinio": "tutorFormato",
        "DVR": "dvr",
        "DPI": "dpi",
        "Consenso Sopralluogo": "consensoSopralluogo",
        "Firma Digitale": "firmaDigitale",
        "Visita Preliminare": {
          field: "idIspezione",
          callback: ((value: any) =>{
            if (value !== null && value !== ""){
              return "Effettuata"
            }else{
              return "Non Effettuata"
            }
          })
        },
        "Data Visita Preliminare": {
          field: "dataIspezione",
          callback: ((value: any) =>{
            if (value !== null && value !== "1/1/1970"){
              return value 
            }else{
              return ""
            }  
          })
        },
      }
    }else if (this.recordType === "dettagliRichiesteTirEstivo" || this.recordType === "dettagliRichiesteTirFormativo" || this.recordType === "dettagliRichiesteTirReIns"){
      // if (this.recordType === "dettagliRichiesteAlternanza"){ 
      //   this.title = "Disponibilità PCTO";
      // }else 
      if (this.recordType === "dettagliRichiesteTirEstivo"){
        this.title = "Disponibilità Tirocinio Estivo";
      }else if(this.recordType === "dettagliRichiesteTirFormativo"){
        this.title = "Disponibilità Tirocinio Formativo";
      }else if(this.recordType === "dettagliRichiesteTirReIns"){
        this.title = "Disponibilità Tirocinio Re/Inserimento"
      }
      this.jsonFields = {
        "Azienda": "denominazioneAzienda",
        "P.Iva": "pIva",
        "Cognome Rappresentante": "cognomeRappresentanteAzienda",
        "Nome Rappresentante": "nomeRappresentanteAzienda",
        "Email Azienda": "emailAzienda",
        "Ateco": "descrizioneAteco",
        "Nome Tirocinante Indicato": "nomeTirocinante",
        "Cognome Tirocinante Indicato": "cognomeTirocinante",
        "Classe Tirocinante Indicato": "classeTirocinante",
        "Lavoratori Sede": "lavoratoriSede",
        "Tirocini Sede": "tirociniSede",
        "Di cui disabili": "tirociniDisabiliSede",
        "Attività": "attivitàTirocinio",
        "Indirizzo Studio": "nomeIndirizzoStudio",
        "Istat": "descrizioneIstat",
        "Uso Fuori Sede": "usoFuoriSede",
        "Indirizzo Tirocinio": "indirizzoTirocinio",
        "Comune Tirocinio": "comuneTirocinio",
        "Cap Tirocinio": "capTirocinio",
        "Provincia Tirocinio": "provinciaTirocinio",
        // "Data Inizio": "dataInizioPeriodo",
        // "Data Fine": "dataFinePeriodo",
        // "Orario Inizio Mattino": "orarioInizioMattino",
        // "Orario Fine Mattino": "orarioFineMattino",
        // "Orario Inizio Pomeriggio": "orarioInizioPomeriggio",
        // "Orario Fine Pomeriggio": "orarioFinePomeriggio",
        "Consulente": "consulente",
        "Denominazione Consulente": "denominazioneConsulente",
        "Referente": "referenteConsulente",
        "Telefono Referente": "telefonoConsulente",
        "Email Referente": "emailConsulente"
      }
    }else if (this.recordType === "assegnazioniAreeAllievi"){
      this.title = 'Assegnazioni Allievi Aree'
      this.jsonFields = {
        "Allievo": "allievo",
        "Email": "email",
        "Anno Corso": "annoCorso",
        "Sezione": "sezione",
        "Area": "nomeArea",
        "Articolazione": "nomeArticolazione",
        "Residenza": "residenza",
        "Data Iscrizione": "dataIscrizione"
      }
    }else if (this.recordType === "assegnazioniAreeAziende"){
      this.title = 'Assegnazioni Aziende Aree'
      this.jsonFields = {
        "Azienda": "denominazioneAzienda",
        "Email": "email",
        "Data Iscrizione": "dataIscrizione",
        "Telefono": "telefono",
        "Area": "nomeArea",
        "Articolazione": "nomeArticolazione",
        "Sede": "sede"
      }
    }else if(this.recordType === 'elencoAllieviTutorForm'){
      this.title = 'Allievi assegnati'
      this.jsonFields = {
        "Allievo": "allievo",
        "Classe": "classe",
        "Telefono Tirocinante": "telefono1Utente",
        "Email Tirocinante": "emailUtente",
        "Azienda Ospitante": "denominazioneAzienda",
        "Data Inizio": "dataInizioPeriodo",
        "Data Fine": "dataFinePeriodo",
        "Orario Inizio Mattino": "orarioInizioMattino",
        "Orario Fine Mattino": "orarioFineMattino",
        "Orario Inizio Pomeriggio": "orarioInizioPomeriggio",
        "Orario Fine Pomeriggio": "orarioFinePomeriggio",
        "Indirizzo Tirocinio": "indirizzoTirocinio",
        "Comune Tirocinio": "comuneTirocinio",
        "Provincia Tirocinio": "provinciaTirocinio",
        "Telefono Azienda": "telefono1Azienda",
        "Email Azienda": "emailAzienda",
        "Tutor Aziendale": "tutorAzienda",
        "Telefono Tutor Az": "telefonoTutor",
        "Email Tutor Az": "emailTutor",
        "Uso Fuori Sede": "usoFuoriSede"
      }
    }else if(this.recordType === 'elencoAllieviIscrittiAlternanza'){
      if (this.recordType === 'elencoAllieviIscrittiAlternanza'){
        this.title = 'Allievi Iscritti PCTO'
      }
      this.jsonFields = {
        "Nome Allievo": "nomeUtente",
        "Cognome Allievo": "cognomeUtente",
        "Email Allievo": "emailUtente",
        "Classe": "classe",
        "Comune Residenza": "comuneUtente",
        "Tutor Articolazione": "tutor",
        "Azienda Assegnata": "azienda",
        "Tutor Formativo": "tutorFormativo",
        "Comune Tirocinio": "comuneTirocinio"
      }
    }else if(this.recordType === 'elencoAssegnazioniAlternanza' || this.recordType === 'elencoAssegnazioniTirEstivi' || this.recordType === 'elencoAssegnazioniTirFormativi' || this.recordType === 'elencoAssegnazioniTirReIns'){
      if(this.recordType === 'elencoAssegnazioniAlternanza'){
        this.title = 'Assegnazioni PCTO'
      } else if(this.recordType === 'elencoAssegnazioniTirEstivi'){
        this.title = 'Assegnazioni Tirocini Estivi'
      } else if(this.recordType === 'elencoAssegnazioniTirFormativi'){
        this.title = 'Assegnazioni Tirocini Formativi'
      } else if(this.recordType === 'elencoAssegnazioniTirReIns'){
        this.title = 'Assegnazioni Tirocini Inserimento/Reinserimento'
      }
      this.jsonFields = {
        "Allievo": "allievo",
        "Classe Allievo": "classe",
        "Comune Residenza": "comuneUtente",
        "Azienda": "azienda",
        "Tutor Formativo": "tutorFormativo",
        "Status Patto": {
          field: "idStatoDoc",
          callback: ((value: any) =>{
            if (value === 1){
              return "Compilato da Confermare"
            }else if(value === 2){
              return "Confermato"
            }else if(value === 3){
              return "Rifiutato"
            }
          })
        },
      }
    }else if(this.recordType === 'elencoSchedulazioneColloqui'){
      this.title = 'Schedulazione Colloqui'  
      this.jsonFields = {
        "Azienda": "denominazione",
        "Allievo": "username",
        "Classe Allievo": "classe",
        "Turno Colloquio": "turno",
        "Area": "area",
        "Giorno Colloquio": "giorno",
        "Settore": "dsArticolazione",
        "Allievo Presente": "allievoPresente",
        "Azienda Presente": "aziendaPresente",
      }
    }else if(this.recordType === 'apprendistati'){
      this.title = 'Apprendistati'  
      this.jsonFields = {
        "#": "idApprendistato",
        "Allievo": "allievo",
        "Classe allievo": "classe",
        "Specializzazione": "nomeArticolazione",
        "Comune allievo": "comuneUtente",
        "Ditta": "denominazioneAzienda",
        "Comune ditta": "comuneAzienda",
        "Anno scolastico": "dsAnnoScolastico",
        "Anno solare": "annoSolare",
        "Diplomato A.S.": "annoDiploma",
        "Passaggio da tirocinio": "passaggioDaTirocinio",
        "Data inizio tirocinio": "dsDataInizioTirocinio",
        "Data fine tirocinio": "dsDataFineTirocinio",
        "Data inizio apprendistato": "dsDataInizioApprendistato",
        "Cessione anticipata": "dsDataFineApprendistato",
        "Tipo di contratto": "tipoContratto",
        "Tipo di contratto post tirocinio": "tipoContrattoPostTirocinio",
        "Proroga": "proroga",
        "Profiling": "profiling",
        "COB": "cob",
        "Note": "note"
      }
    }
  }
}
